module.exports = __webpack_public_path__ + "fonts/Inter-Black-slnt=0.5f2ce7df.ttf";